export default __webpack_public_path__ + "static/django-development-company-peerbits-d44f131f7a11766966ee1ac6c7a30fb6.png";